import React, { useEffect, useState, lazy, Suspense } from 'react';
import styled, {createGlobalStyle} from 'styled-components'

import {setEnvValue, APP_VENDOR} from "Utils/Constants";
import {setAssets, fontList} from 'View/helper';
import { getAppConfig, getImagesFile, getThemeFile, getTableAssets } from 'Data/common/actions/commonActions';
import { getConfig, setConfigCookie, getStoredTableAssets } from 'View/helper';
import Loader from 'View/Shared/NetworkLoader';

const LoaderWrapper = styled.div`
    background-color: black;
    height: 100%;
    width: 100%;
`

export default function ConsumerConfig(){

    const [configVal, setConfig] = useState("");
    const [pokerThemeMap, setThemeMap] = useState("");
    const [imagesFile, setImagesFile] = useState("");
    const [showLoader, setShowLoader] = useState(true);


    useEffect(()=> {
        let prevConfig = getConfig();
        if(prevConfig && prevConfig !== "" && window.location.pathname.indexOf("lobby") < 0){ // adding checks for lobby and m/lobby so that on lobby config call is done everytime.
            setConfig(prevConfig);
        }
        else
            getAppConfig((pl)=>setConfig(pl));
        getThemeFile(setThemeMap);
        getImagesFile(setImagesFile);
        // calling config apis and S3 urls
    },[]);

    useEffect(()=>{
        if(configVal !== "" && pokerThemeMap !== "" && imagesFile !== ""){
            const config = {
                leader_board: true,
                consumer: "web",
                walletType: "single",
                apiConfig: configVal,
                pokerThemeMap: pokerThemeMap,
                isPokerAllowed: true,
                assetsMap: imagesFile
            };
            if( window.location.pathname.includes("lobby") && APP_VENDOR === "p52"){
                checkAssetsVer();
            }
            setConfigCookie(configVal); // storing config in cookie so we don't need to call the config api every time for table,mtt and HH window
            setEnvValue(process.env, config);
            setAssets(pokerThemeMap, imagesFile, ()=>{
                setShowLoader(false);
            });
        }        
    },[configVal, pokerThemeMap, imagesFile]);

    const checkAssetsVer = ()=>{
        let prevTableAssets = getStoredTableAssets();
        if(prevTableAssets.ver && configVal.misc && configVal.misc.asset_ver){
            if(prevTableAssets.ver != configVal.misc.asset_ver){
                getTableAssets();
            }
        } else{
            getTableAssets();
        }
    }

    const LazyLoadAPP = lazy(() => import("./App"));

    const RenderApp = ()=> { // rendering app.js
        const GlobalStyle = createGlobalStyle`
        ${fontList()}
        `;
        return(
            <>
                <GlobalStyle/>
                <LazyLoadAPP/>
            </>
        )
    }

    const LoaderComponent = () => {
        return(
            <LoaderWrapper>
                <Loader fullOpacity={true}/>
            </LoaderWrapper>
        )
    } 

    return(
        <>
        {   
            showLoader ?
                <LoaderComponent/>
            :
            <Suspense fallback={<LoaderComponent/>}>
                <RenderApp/>
            </Suspense>
        } 
        </>
    )
}